/* eslint class-methods-use-this: off */

import { AUTH0_AUTH_URL, AUTH0_CLIENT_ID } from '../../constants/constants';
import BaseAuthUrls from './BaseAuthUrl';

/**
 * Utilities for building Auth0 Auth URLs and Functions.
 */
export default class Auth0AuthUrls extends BaseAuthUrls {
  getIdP(): string {
    return AUTH0_AUTH_URL;
  }

  getLoginUrl(): string {
    const loginUrl: string = [
      AUTH0_AUTH_URL,
      '/authorize',
      '?response_type=token',
      `&client_id=${AUTH0_CLIENT_ID}`,
      `&redirect_uri=${window.location.origin}/`,
      '&scope=openid%20profile%20email%20vtms-internal-api%20ecw-api',
      '&audience=verx://migration-api',
    ].join('');

    return loginUrl;
  }

  getLogoutUrl(): string {
    const classLogoutUrl: string = [
      AUTH0_AUTH_URL,
      '/v2/logout',
      `?client_id=${AUTH0_CLIENT_ID}`,
      `&returnTo=${window.location.origin}/`,
    ].join('');

    return classLogoutUrl;
  }

  getTokenRequestUrl(): string {
    const tokenRequestUrl: string = [
      AUTH0_AUTH_URL,
      '/authorize',
      '?response_type=token',
      `&client_id=${AUTH0_CLIENT_ID}`,
      `&redirect_uri=${window.location.origin}/token/result/index.html`,
      '&scope=openid%20profile%20email%20vtms-internal-api%20ecw-api',
      '&audience=verx://migration-api',
    ].join('');

    return tokenRequestUrl;
  }
}
